interface MinimalContact {
  Id?: number;
  Email: string;
  [key: string]: any;
}

export const isContactSelected = (
  contact: MinimalContact,
  selectedContacts: MinimalContact[]
): boolean =>
  selectedContacts.some(
    selectedContact =>
      contact?.Email?.toLowerCase() === selectedContact?.Email?.toLowerCase()
  );
